<template>
  <Modal
    :active="isOpen"
    title="Histórico de Alterações"
    @close="closeModal"
    id="endorsement-history-modal"
  >
    <div class="modal-content">
      <vs-table
        v-if="historyData.length"
        :data="historyData"
        class="history-table"
      >
        <template slot="thead">
          <vs-th>Campo</vs-th>
          <vs-th>Valor Anterior</vs-th>
          <vs-th>Novo Valor</vs-th>
          <vs-th>Data Alteração</vs-th>
          <vs-th>Responsável</vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr v-for="(row, index) in data" :key="index">
            <vs-td class="nowrap">{{ translateField(row.field) }}</vs-td>
            <vs-td>{{ row.oldData || '-' }}</vs-td>
            <vs-td>{{ row.newData || '-' }}</vs-td>
            <vs-td>{{ formatDate(row.createdAt) }}</vs-td>
            <vs-td>{{ row.user }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <p v-else>Nenhum dado encontrado.</p>
    </div>
  </Modal>
</template>

<script>
import Modal from '../../../../../components/Modal.vue';
import endorsement from '../../../../../services/endorsement';
import { ENDORSEMENT_FIELDS_TRANSLATIONS } from '../../../../../utils/fieldTranslations';
import notify from '../../../../../utils/notify';

export default {
  name: 'EndorsementHistoryModal',
  components: { Modal },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    operationTypeId: {
      type: [Number, null],
      required: false,
    },
  },
  data() {
    return {
      historyData: [],
      fieldTranslations: ENDORSEMENT_FIELDS_TRANSLATIONS,
    };
  },
  watch: {
    isOpen(newValue) {
      if (newValue) {
        this.fetchHistory();
      }
    },
  },
  methods: {
    async fetchHistory() {
      if (!this.operationTypeId) return;

      try {
        const response = await endorsement.getOperationTypeHistory(
          this.operationTypeId,
        );
        this.historyData = response || [];
      } catch (error) {
        notify.notifyFail(
          this.$vs,
          'Erro ao carregar histórico de alterações.',
        );
      }
    },
    closeModal() {
      this.$emit('close');
    },
    formatDate(date) {
      return new Date(date).toLocaleString('pt-BR');
    },
    translateField(fieldName) {
      return this.fieldTranslations[fieldName] || fieldName;
    },
  },
};
</script>

<style>
#endorsement-history-modal.con-vs-popup .vs-popup {
  min-width: 880px;
  max-width: 1200px;
  width: auto;
}
</style>
